import { Modal } from '@/shared/ui/Modal/Modal';
import { Button } from '@/shared/ui/Button/Button';
import { Input } from '@/shared/ui/Input/Input';
import { useState, useEffect } from 'react';
import s from './BlockReasonModal.module.scss';
import { useScreenDetector } from '@/shared/lib/hooks/useScreenDetector';

interface BlockReasonModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
}

export const BlockReasonModal = (props: BlockReasonModalProps) => {
  const { open, onClose, onConfirm } = props;
  const { isMobile } = useScreenDetector();
  const [reason, setReason] = useState('Нарушение условий использования сервиса');

  useEffect(() => {
    if (open) {
      setReason('Нарушение условий использования сервиса');
    }
  }, [open]);

  const handleConfirm = () => {
    if (reason.trim()) {
      onConfirm(reason.trim());
      onClose();
    }
  };

  return (
    <Modal onClose={onClose} open={open} title={'Введите причину блокировки'} titleSize={'h1'}>
      <div className={s.wrapper}>
        <Input
          label="Причина блокировки"
          value={reason}
          onChange={(e) => setReason(typeof e === 'string' ? e : e.target.value)}
          error={!reason.trim() ? 'Причина блокировки не может быть пустой' : ''}
          placeholder="Укажите причину блокировки"
          baseAddon={false}
        />
      </div>
      <div className={s.actions}>
        <Button color={'red'} onClick={handleConfirm} disabled={!reason.trim()} size={isMobile ? 's' : 'm'}>
          ОК
        </Button>
        <Button color={'red'} variant={'outline'} onClick={onClose} size={isMobile ? 's' : 'm'}>
          Отменить
        </Button>
      </div>
    </Modal>
  );
};
